<template>
  <div>
    <v-btn
      color="primary"
      class="mb-4 me-3"
      outlined
      small
      @click="openDialog"
    >
      <v-icon>{{ icons.mdiAccountPlusOutline }}</v-icon>
      <span>{{ $t('Assigner') }}</span>
    </v-btn>
    <v-dialog
      v-model="collectionUserDialog"
      transition="dialog-top-transition"
      max-width="500px">
      <v-card>
        <v-card-title>
          <div class="text-center">
            Assigner un responsable
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
            >
              <v-select
                v-model="selectedUserId"
                :items="groupedOptions"
                :rules="[v => !!v || 'Veuillez sélectionner un assistant']"
                label="Sélectionner un assistant"
                item-text="text"
                item-value="value"
                outlined
                dense
              />

            </v-col>
            <v-col
              cols="12"
            >
              <v-autocomplete
                v-model="selectedQuota"
                :label="$t('Quota')"
                :error-messages="'Le quota est requis'"
                :items="quotaOptions"
                item-text="label"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                clearable
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.value }}%</span>
                </template>
                <template v-slot:item="{ item }">
                  <span>{{ item.value }}%</span>
                </template>

              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="collectionUserDialog = false"
          >
            {{ $t('Annuler') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="loading"
            :disabled="!selectedUserId && !selectedQuota"
            color="primary"
            class="me-3"
            @click="setCollectionUser"
          >
            {{ $t('Enregistrer') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import axios from '@axios'
import { mdiAccountPlusOutline } from '@mdi/js'
import store from '@/store'

export default defineComponent({
  name: 'CollectionUserForm',
  components: {},
  model: {
    prop: 'modelValue',
  },
  props: {
    modelValue: {
      type: [Number, Array],
      default: null,
    },
  },
  setup(props, { emit }) {
    const collectionUsers = computed({
      get: () => props.modelValue,
      set: val => {
        emit('input', val)
      },
    })

    const colUsers = ref([])
    const loading = ref(true)
    const collectionUserDialog = ref(false)
    const selectedQuota = ref(null)
    const groupedOptions = ref([])

    const quotaOptions = Array.from({ length: 20 }, (_, i) => {
      const value = (i + 1) * 5

      return {
        label: `${value}%`,
        value,
      }
    })

    const selectedUserId = ref(null)

    onMounted(async () => {
      if (props.modelValue) {
        fetchUsersToApply(props.modelValue)
      }
    })

    function openDialog() {
      fetchUsersToApply(props.modelValue)
      collectionUserDialog.value = true
    }

    function setCollectionUser() {
      loading.value = true
      if (selectedQuota.value && selectedUserId.value) {
        store.dispatch('collection/setCollectionUser', {
          collection_id: props.modelValue,
          user_id: selectedUserId.value,
          quota: selectedQuota.value,
        }).then(response => {
          loading.value = false
          collectionUserDialog.value = false
          emit('collection-user-updated', props.modelValue)
        }).catch(() => {
          loading.value = false
        })
      }
    }

    function fetchUsersToApply(id_collection) {
      loading.value = true
      axios.get(`collection-users-to-apply/${id_collection}`)
        .then(response => {
          colUsers.value = response.data

          groupedOptions.value = colUsers.value.map(user => {
            const roleLabel = typeof user.long_roles_names === 'object'
              ? Object.values(user.long_roles_names)?.[0]?.trim()
              : user.long_roles_names?.trim()

            return {
              text: `${user.name} (${roleLabel})`,
              value: user.id,
            }
          })

          loading.value = false
        })
        .catch(() => {
          loading.value = false
        })
    }

    return {
      collectionUsers,
      colUsers,
      loading,
      openDialog,
      setCollectionUser,
      selectedQuota,
      groupedOptions,
      quotaOptions,
      selectedUserId,
      collectionUserDialog,
      icons: { mdiAccountPlusOutline },
    }
  },
})
</script>

<style scoped lang="scss">

</style>
